<template>
    <div>
        <a-form id="form-detail-banner" :form="form" class="row" layout="horizontal" @submit="submitSave">

            <a-form-item class="col-md-6">
            <h5>Imagen para web</h5>

            <a-upload-dragger
                name="image_web"
                :multiple="false"
                :showUploadList="false"
                class="avatar-uploader"
                action="#" @change="handleChangeUploadWeb">

                <img v-if="imageUrl" :src="imageUrl" alt="avatar" class="rounded-pill" style="max-height:50px; max-width:200px" />
                <!-- <a-icon  v-if="isLoadingWeb" type="loading" /> -->

                <div class="row" v-if="imageUrl == ''">
                    <div class="col-sm-3">

                        <p class="ant-upload-drag-icon">
                            <a-icon  :type="isLoadingWeb ? 'loading' : 'inbox'" />
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <p class="ant-upload-text">Clic aquí o arrastre archivo aqui.</p>
                        <p class="ant-upload-hint">Soporta archivos .jpg </p>
                    </div>
                </div>
            </a-upload-dragger>
          </a-form-item>

          <a-form-item class="col-md-6">
            <h5>Imagen para Movil</h5>

             <a-upload-dragger
                name="image_movile"
                :multiple="false"
                :showUploadList="false"
                class="avatar-uploader"
                action="#" @change="handleChangeUploadMovil">

                <img v-if="imageUrlMovil" :src="imageUrlMovil" alt="avatar" class="rounded-pill" style="max-height:50px; max-width:200px" />

                <div class="row" v-if="imageUrlMovil == ''">
                    <div class="col-sm-3">

                        <p class="ant-upload-drag-icon">
                            <a-icon  :type="isLoadingMovil ? 'loading' : 'inbox'" />
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <p class="ant-upload-text">Clic aquí o arrastre archivo aqui.</p>
                        <p class="ant-upload-hint">Soporta archivos .jpg </p>
                    </div>
                </div>
            </a-upload-dragger>

          </a-form-item>

            <a-form-item class="col-md-6">
                <h5>Titulo:</h5>
                <a-input placeholder="Ej. Madrugón" v-decorator="['title', { rules: [{ required: true, message: 'Campo requerido!' }] }]" />
            </a-form-item>
            <a-form-item class="col-md-4">
                <h5>Fecha de Finalización:</h5>
                <a-date-picker v-decorator="['expireDate', { rules: [{ required: true, message: 'Campo requerido!' }] }]" 
                    placeholder="Ej. 23/12/2019" :disabled-date="disabledDate"></a-date-picker>
            </a-form-item>
            <a-form-item class="col-md-2">
                <h5>Orden:</h5> 
                <a-input-number placeholder="Ej. 3" :min="1" :parser="value => Math.floor(value)" v-decorator="['position', { rules: [{ required: true, message: 'Campo requerido!' }] }]" />
            </a-form-item>
            <a-form-item class="col-md-6">
                <h5>Segmentos:</h5>
                <a-select mode="multiple" placeholder="Seleccione los segementos..." v-decorator="['segmentIds', { rules: [{ required: true, message: 'Campo requerido!' }], initialValue: [] }]">
                    <a-select-option  v-for="item in segments" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item class="col-md-6">
                <h5>Campaña:</h5>
                <a-select v-decorator="['campaignId', { rules: [{ required: true, message: 'Campo requerido!' }] }]"  placeholder="Seleccione Campaña"  >
                    <a-select-option  v-for="item in campaigns" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item class="col-md-4">
                <h5>Android Url:</h5>
                <a-input placeholder="https://www.farmatodo.com/android..." v-decorator="['androidUrl', { rules: [{ required: true, message: 'Campo requerido!' }] }]" />
            </a-form-item>
            <a-form-item class="col-md-4">
                <h5>iOS Url:</h5>
                <a-input placeholder="https://www.farmatodo.com/ios..." v-decorator="['iosUrl', { rules: [{ required: true, message: 'Campo requerido!' }] }]" />
            </a-form-item>
            <a-form-item class="col-md-4">
                <h5>Web Url:</h5>
                <a-input placeholder="https://www.farmatodo.com/web..." v-decorator="['webUrl', { rules: [{ required: true, message: 'Campo requerido!' }] }]" />
            </a-form-item>
            <a-form-item class="col-md-12">
                <h5>Descripción:</h5>
                <a-textarea v-decorator="['description', { rules: [{ required: true, message: 'Campo requerido!' }], initialValue: '' }]" placeholder="Ingrese descripción" :auto-size="{ minRows: 3, maxRows: 5 }" />
            </a-form-item>

            <div :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                    }" >

                <a-button :style="{marginRight: '8px'}" type="primary" html-type="submit" :loading="loadingSave">Guardar</a-button>
                <a-button :style="{marginRight: '8px'}"  @click="close()"> Cerrar </a-button>
            </div>
        </a-form>
    </div>
</template>

<script>
import { RepositoryFactory } from '../../../repository/RepositoryFactory'
import moment from 'moment'
import UploadRepository from '@/repository/uploadRepository'
const BrazeRepository = RepositoryFactory.get('braze')

export default {
    name: 'ItemDetail',
    props: ['content', 'isUpdated'],
    data() {
        return  {
            form: this.$form.createForm(this, { name: 'brazeForm' }),
            imageUrl: '',
            imageUrlMovil: '',
            segments: [],
            campaigns: [],
            loadingSave: false,
            isLoadingWeb: false,
            isLoadingMovil: false
        }
    }, 
     mounted() {
        this.fetchSegmets(),
        this.fetchCampaigns()
    },
    created() {
        console.log('hola');
    },
    methods: {
        disabledDate(current) {
            return current && current > moment().add(30, 'days').endOf('day');
        },
        async fetchSegmets() {
            try {
                const { data } = await BrazeRepository.getAllSegmentList();
                this.segments = data.data
            } catch (error) {
                this.$notification['warning']({
                    message: error.code,
                    description: error.message,
                });
            }
        },
        async fetchCampaigns() {
            try {
                const { data } = await BrazeRepository.getAllCampaignsList();
                console.log(data.data)
                this.campaigns = data.data
            } catch (error) {
                this.$notification['warning']({
                    message: error.code,
                    description: error.message,
                });
            }
        },
        async submitSave(e) {
            e.preventDefault()

            this.form.validateFields((err, values) => {
                if (!err) {
                    values['imageUrl'] = this.imageUrl;
                    values['imageUrlMobile'] = this.imageUrlMovil;

                    try {
                        this.loadingSave = true;
                        BrazeRepository.uploadContentCard(values).then(({ data }) => {
                            this.loadingSave = false;

                            this.$notification['success']({
                                message: 'Registro exitso',
                                description: 'Se ha creado Content Card exitosamente',
                            });
                            this.campaigns.splice(this.campaigns.findIndex(i => i.id == values.campaignId), 1);
                            this.close();
                        })
                    } catch (error) {
                        this.$notification['warning']({
                            message: 'Error',
                            description: error.message,
                        })
                    }

                    return;
                }
                this.$notification['warning']({
                    message: 'Error de formulario',
                    description: 'Vérifique los campos',
                });
            })
        },
        close() {
            this.$emit('closeDetail', false);
            this.form.resetFields();
            this.imageUrl = '';
            this.imageUrlMovil = '';
            this.isLoadingWeb = false;
            this.isLoadingMovil = false;
        },
        handleChangeUploadWeb(info) {
            console.log(info)
            if(this.isLoadingWeb) return;
            this.imageUrl = ''
            this.isLoadingWeb = true

            try {
                UploadRepository.uploadImage(info.file.originFileObj).then(({ data }) => {
                    this.imageUrl = data.link
                    this.content.imageUrl = data.link
                    this.isLoadingWeb = false
                })
            } catch (error) {
                console.log(error)
                this.isLoadingWeb = false
                this.$notification['warning']({
                message: error.code,
                description: error.message,
                })
            }
        },
        handleChangeUploadMovil(info) {
            if(this.isLoadingMovil) return;
            this.imageUrlMovil = ''
            this.isLoadingMovil = true

            try {
                UploadRepository.uploadImage(info.file.originFileObj).then(({ data }) => {
                this.imageUrlMovil = data.link
                this.banner.imageUrlMovil = data.link
                this.isLoadingMovil = false
                })
            } catch (error) {
                console.log(error)
                this.isLoadingMovil = false
                this.$notification['warning']({
                    message: error.code,
                    description: error.message,
                })
            }
        },
    }
}

</script>

<style lang="css">
    .ant-drawer-title{
        color:#001e62;
        font-weight: bold;
        font-size: 15pt;
        font-family: 'Open Sans Condensed', sans-serif;
        text-transform: uppercase
    }
    h5{
        color:#001e62;
        font-weight: bold;
        font-size: 12pt;
        font-family: 'Open Sans Condensed', sans-serif;
    }
    p.ant-upload-drag-icon {
        text-align: center;
        padding: 0px 10px;
        display: block;
        margin: 0px!important;
    }

    p.ant-upload-text {

        font-size: 14px!important;

    }

    .ant-upload-drag-container {padding: 0px; line-height: 13px;}

    span.ant-upload.ant-upload-btn {
        padding: 0px!important;
        /* border: 1px #ddd dotted; */
    }

    .ant-upload.ant-upload-drag {
        border: 2px dashed #e4e9f0;
        background-color: transparent;
        height: 70px;
    }

    .ant-upload.ant-upload-drag p.ant-upload-text{
            margin: 10px 0 1px;
    }

    .flip-list-move {
    transition: transform 0.5s;
    }
    .no-move {
    transition: transform 0s;
    }
    .ghost {
    opacity: 0.5;
    background: #c8ebfb;
    }
    .list-group {
    min-height: 20px;
    }
    .list-group-item {
    cursor: move;
    }
    .list-group-item i {
    cursor: pointer;
    }
</style>